import { useEffect } from "react";
import { useCallbackRef } from "../../../util/hooks/index.js";
export function useEscapeKeydown(callback, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = useCallbackRef(callback);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onEscapeKeyDown(event);
            }
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, true);
        return () => ownerDocument.removeEventListener("keydown", handleKeyDown, true);
    }, [onEscapeKeyDown, ownerDocument]);
}
//# sourceMappingURL=useEscapeKeydown.js.map